<template>
  <div class="bet-record-page">
    <!--顶部header 和主页面保持一致-->
    <div class="header">
      <div class="back" @click="$router.back()">‹</div>
      <div class="title">我的下注记录</div>
      <div class="tools"></div>
    </div>

    <div class="content">
      <div v-if="loading" class="loading-tip">加载中...</div>
      <div v-if="!loading && tableData.length <= 0" class="empty-tip">暂无下注记录</div>

      <div class="record-list" v-else>
        <div class="record-item" v-for="row in tableData" :key="row.id">
          <div class="item-head">
            <span class="period">期号：{{ row.period }}</span>
            <span class="status-tag" :class="statusClass(row.status)">
              {{ statusMap[row.status] }}
            </span>
          </div>
          <div class="item-body">
            <div class="row-line">
              <span class="label">玩法：</span>
              <span class="val">{{ getBetName(row.bet_type, row.bet_sub) }}</span>
            </div>
            <div class="row-line">
              <span class="label">下注金额：</span>
              <span class="val money-red">￥{{ row.bet_money }}</span>
            </div>
            <div class="row-line">
              <span class="label">赔率：</span>
              <span class="val">{{ row.odds }}</span>
            </div>
            <div class="row-line">
              <span class="label">中奖金额：</span>
              <span class="val money-win">￥{{ row.win_money }}</span>
            </div>
            <div class="row-line">
              <span class="label">下注时间：</span>
              <span class="val">{{ row.bet_at }}</span>
            </div>
          </div>
        </div>
      </div>

      <!--分页区域-->
      <div class="pagination-wrap" v-if="total > 0">
        <button class="page-btn" :disabled="page <=1" @click="prevPage">上一页</button>
        <span class="page-text">{{ page }} / {{ lastPage }}</span>
        <button class="page-btn" :disabled="page >= lastPage" @click="nextPage">下一页</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'game28record',
  data(){
    return {
      loading:false,
      tableData:[],
      page:1,
      limit:15,
      total:0,
      lastPage:0,
      //状态映射 和数据库game_28_bet status字段一一对应
      statusMap:{
        0:'待结算',
        1:'中奖',
        2:'未中奖',
        3:'已撤单'
      }
    }
  },
  mounted(){
    this.fetchRecordList()
  },
  methods:{
    //状态样式class
    statusClass(s){
      switch (s){
        case 0: return 'status-info'
        case 1: return 'status-success'
        case 2: return 'status-danger'
        case 3: return 'status-warn'
        default: return ''
      }
    },

    //和主页面完全一致的玩法名称转换
    getBetName(betType, betSub){
      const map={
        big:'大', small:'小', single:'单', double:'双',
        small_single:'小单', big_double:'大双', small_double:'小双', big_single:'大单',
        min_extreme:'极小', max_extreme:'极大', duizi:'对子', shunzi:'顺子', baozi:'豹子',
        long:'龙', hu:'虎', bao:'豹'
      }
      if(betType === 'number'){
        return betSub || '-'
      }
      return map[betType] || betType
    },

    async fetchRecordList(){
      this.loading = true
      try{
        const res = await this.$apiFun.get('/api/game28/betList',{
          params:{
            page:this.page,
            limit:this.limit
          }
        })
        if(res.code === 0){
          this.tableData = res.data.list
          this.total = res.data.total
          this.lastPage = res.data.last_page
        }else if(res.code === 401){
          this.$parent.showTost(0,'登录失效，请重新登录')
          this.$router.back()
        }else{
          this.$parent.showTost(0,res.msg||'获取记录失败')
        }
      }catch (e){
        console.error('获取下注记录异常',e)
        this.$parent.showTost(0,'网络异常')
      }finally {
        this.loading = false
      }
    },

    prevPage(){
      if(this.page <=1) return
      this.page--
      this.fetchRecordList()
    },
    nextPage(){
      if(this.page >= this.lastPage) return
      this.page++
      this.fetchRecordList()
    }
  }
}
</script>

<style scoped>
*{
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.bet-record-page{
  width:100vw;
  height:100vh;
  display:flex;
  flex-direction:column;
  background:#f2f5fa;
  font-size:14px;
  color:#111;
  overflow:hidden;
}

.header{
  height:60px;
  flex-shrink:0;
  background:#fff;
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:0 18px;
}
.back{
  font-size:42px;
  font-weight:200;
}
.title{
  font-size:20px;
}
.tools{
  width:40px;
}

.content{
  flex:1;
  overflow-y:auto;
  padding:12px;
}

.loading-tip,.empty-tip{
  text-align:center;
  padding:40px 0;
  color:#888;
}

.record-list{
  display:flex;
  flex-direction:column;
  gap:12px;
}

.record-item{
  background:#ffffff;
  border-radius:12px;
  padding:14px 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}

.item-head{
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding-bottom:10px;
  border-bottom:1px solid #f1f1f1;
  margin-bottom:10px;
}
.period{
  font-size:15px;
  color:#325ac4;
  font-weight:500;
}

.status-tag{
  padding:3px 12px;
  border-radius:20px;
  font-size:13px;
}
.status-info{
  background:#e8edf4;
  color:#446099;
}
.status-success{
  background:#e6f9ed;
  color:#289b52;
}
.status-danger{
  background:#ffe9e9;
  color:#d63030;
}
.status-warn{
  background:#fff7e6;
  color:#cc8822;
}

.item-body{
  display:flex;
  flex-direction:column;
  gap:8px;
}
.row-line{
  display:flex;
}
.label{
  width:90px;
  color:#666;
}
.val{
  flex:1;
}
.money-red{
  color:#e64340;
}
.money-win{
  color:#289b52;
}

.pagination-wrap{
  display:flex;
  justify-content:center;
  align-items:center;
  gap:16px;
  padding:24px 0;
}
.page-btn{
  padding:8px 20px;
  border-radius:8px;
  border:none;
  background:#fff;
  box-shadow:0 1px 3px #ddd;
}
.page-btn:disabled{
  opacity:0.4;
}
.page-text{
  color:#555;
}
</style>


// WEBPACK FOOTER //
// src/components/game28record.vue